import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArcaLogsService {

constructor(private http: HttpClient) { }

  getLogs(searchFilters, page = 1, count = 100)
  {
    const body = {
      creationDateEnd: searchFilters.end,
      creationDateStart: searchFilters.start,
      keys:{
        arca_api_type:searchFilters.arca_api_type
      }
    }
    return this.http.post(`api/payment/GetArcaLogs?page=${page}&count=${count}`, body, {observe: 'response'})
  }
}
